import { useQuery } from "@apollo/client";
import {  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import {  useState,useMemo } from "react";
import { GET_DOCUMENTS } from "../../components/graphql";
import { Layout } from "../../components/layout/layout";
import { useCustomNavigate } from "../../provider/navigate";

interface StateObject {
	expanded: string;
	lectureType: string;
	searchKey: string;
	sortKey: string;
  }
  
const initState: StateObject = {
	expanded: "",
	lectureType: "all",
	searchKey: "",
	sortKey: "",
};

const Pdf = () => {
	const { data: documentData, loading, error } = useQuery(GET_DOCUMENTS, {
		pollInterval: 500,
	});

	const { navigate } = useCustomNavigate();
	const [state, setState] = useState<StateObject>(initState);

	const updateState = (data: Partial<StateObject>) => {
	setState({ ...state, ...data });
	};

	const documentDatas: any[] = useMemo(() => {
	if (!!loading || !!error) return [];
	return [...documentData.getDocuments]
		.filter(({ title, owner }: any) =>
		title.toLowerCase().includes(state.searchKey.toLowerCase().trim()) ||
		owner.email.toLowerCase().includes(state.searchKey.toLowerCase().trim())
		)
		.sort((a, b) => {
		switch (state.sortKey) {
			case "TitleASC":
			return a.title.localeCompare(b.title);
			case "TitleDESC":
			return b.title.localeCompare(a.title);
			case "OwnerASC":
			return a.owner.name.localeCompare(b.owner.name);
			case "OwnerDESC":
			return b.owner.name.localeCompare(a.owner.name);
			case "PriceASC":
			return a.price - b.price;
			case "PriceDESC":
			return b.price - a.price;
			case "LanguageASC":
			return a.language.localeCompare(b.language);
			case "LanguageDESC":
			return b.language.localeCompare(a.language);
			default:
			return 0;
		}
		});
	}, [documentData, loading, error, state.searchKey, state.sortKey]);

	const handleRowClick = (pdfId: string) => {
		navigate(`/pdf/${pdfId}`); // Adjust the path as needed
	};

	return (
		<Layout>
			<TableContainer component={Paper} style={{ maxWidth: '80%', margin: 'auto', height: '60vh' }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>No</TableCell>
							<TableCell>Title</TableCell>
							<TableCell>Language</TableCell>
							<TableCell>Type</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{documentDatas.map((pdf, i) => (
							<TableRow key={pdf.id} onClick={() => handleRowClick(pdf.id)} style={{ cursor: 'pointer' }}>
								<TableCell>{i + 1}</TableCell>
								<TableCell>{pdf.title}</TableCell>
								<TableCell>{pdf.language}</TableCell>
								<TableCell>{pdf.lectureType}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Layout>
	)
}

export { Pdf }
